import { CartAddEvent, CartUpdateEvent } from '@theme/events';
const MAIN_VARIANT_ID = '49801929523531';
const GIFT_VARIANT_ID = '53370832814411';
let requestInFlight = false;

function sectionIds() {
  return [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((item) => item.dataset.sectionId).filter(Boolean))];
}
async function postCart(path, body) {
  const response = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const data = await response.json();
  if (!response.ok || data.status) throw new Error(data.description || data.message || 'Warenkorb konnte nicht aktualisiert werden.');
  return data;
}
function dispatchCart(data, source, addedQuantity = 0) {
  const detail = { source, itemCount: addedQuantity, productId: MAIN_VARIANT_ID, sections: data.sections || {} };
  document.dispatchEvent(addedQuantity > 0 ? new CartAddEvent({}, MAIN_VARIANT_ID, detail) : new CartUpdateEvent({}, source, detail));
}
async function addBundle(quantity = 1, source = 'pfp-bundle') {
  if (requestInFlight) return;
  requestInFlight = true;
  const ids = sectionIds();
  try {
    const data = await postCart(Theme.routes.cart_add_url, {
      items: [
        { id: Number(GIFT_VARIANT_ID), quantity },
        { id: Number(MAIN_VARIANT_ID), quantity },
      ],
      sections: ids.join(','), sections_url: window.location.pathname,
    });
    dispatchCart(data, source, quantity);
  } finally { requestInFlight = false; }
}
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-pfp-empty-add]') : null;
  if (!button || button.dataset.pfpSubmitting === 'true' || document.documentElement.dataset.pfpBundleBusy === 'true') return;
  button.dataset.pfpSubmitting = 'true';
  document.documentElement.dataset.pfpBundleBusy = 'true';
  button.setAttribute('aria-busy', 'true'); button.disabled = true;
  try { await addBundle(1, 'pfp-empty-cart'); }
  catch (error) { console.error(error); window.location.href = '/products/boxsack'; }
  finally {
    button.removeAttribute('aria-busy');
    button.disabled = false;
    delete button.dataset.pfpSubmitting;
    delete document.documentElement.dataset.pfpBundleBusy;
  }
});
class PunchFitCartSync extends HTMLElement {
  connectedCallback() { this.sync(); }
  async sync() {
    if (requestInFlight || this.dataset.synced === 'true') return;
    this.dataset.synced = 'true';
    const mainQuantity = Number(this.dataset.mainQuantity) || 0;
    const giftQuantity = Number(this.dataset.giftQuantity) || 0;
    const giftKeys = (this.dataset.giftKeys || '').split(',').filter(Boolean);
    const giftLineCount = Number(this.dataset.giftLineCount) || giftKeys.length;
    if (mainQuantity === giftQuantity && giftLineCount <= 1) return;
    requestInFlight = true;
    const ids = sectionIds();
    try {
      let data;
      if (giftKeys.length === 0 && mainQuantity > 0) {
        data = await postCart(Theme.routes.cart_add_url, { items: [{ id: Number(GIFT_VARIANT_ID), quantity: mainQuantity }], sections: ids.join(','), sections_url: window.location.pathname });
      } else if (giftKeys.length > 0) {
        const updates = {};
        giftKeys.forEach((key, index) => { updates[key] = index === 0 ? mainQuantity : 0; });
        data = await postCart(Theme.routes.cart_update_url + '.js', { updates, sections: ids.join(','), sections_url: window.location.pathname });
      }
      if (data) dispatchCart(data, 'pfp-cart-sync');
    } catch (error) { console.error(error); }
    finally { requestInFlight = false; }
  }
}
if (!customElements.get('pfp-cart-sync')) customElements.define('pfp-cart-sync', PunchFitCartSync);


let giftSyncTimer;
function scheduleNativeGiftSync(event) {
  if (event?.detail?.source === 'pfp-cart-sync' || event?.detail?.data?.source === 'pfp-cart-sync') return;
  window.clearTimeout(giftSyncTimer);
  giftSyncTimer = window.setTimeout(() => {
    const syncElement = document.querySelector('pfp-cart-sync');
    if (!syncElement || typeof syncElement.sync !== 'function') return;
    syncElement.dataset.synced = 'false';
    syncElement.sync();
  }, 350);
}
document.addEventListener('cart:add', scheduleNativeGiftSync);
document.addEventListener('cart:update', scheduleNativeGiftSync);
